export default __webpack_public_path__ + "static/media/client-7.ecf467a8.png";